import { useState } from 'react';
import { Controller } from 'react-hook-form';

import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';
import { Xmark } from '@gravity-ui/icons';
import styles from '../styles.module.scss';

export const GenderSelect = ({ isMobile, formText, control, formValues, genderOptions, errors }: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow className={`${styles.info__row} ${styles.right}`} label={formText.genderBlank} required>
					<Controller
						control={control}
						name="gender"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => {
							return (
								<Select
									width={100}
									className={styles.info__row__select}
									size="xl"
									value={[formValues.gender]}
									onUpdate={(values) => onChange?.(values[0])}
									options={genderOptions}
									validationState={error ? 'invalid' : undefined}
									errorPlacement="inside"
									errorMessage={error?.message}
									onBlur={onBlur}
									ref={ref}
									open={isOpen}
									onOpenChange={setIsOpen}
									renderPopup={({ renderList }) => (
										<Sheet
											visible={isOpen}
											onClose={() => setIsOpen(false)}
											title="Выберите пол"
											className={styles.sheet}
										>
											<div className={styles.sheet__close}>
												<Button onClick={() => setIsOpen(false)} view="flat">
													<Icon data={Xmark} size={16} />
												</Button>
											</div>
											<div className={styles.sheet__content}>{renderList?.()}</div>
										</Sheet>
									)}
								/>
							);
						}}
					/>
				</FormRow>
			) : (
				<FormRow className={`${styles.info__row} ${styles.right}`} label={formText.genderBlank} required>
					<Controller
						control={control}
						name="gender"
						render={({ field: { onChange, onBlur, ref }, fieldState: { error } }) => (
							<Select
								width={100}
								className={styles.info__row__select}
								size="xl"
								value={[formValues.gender]}
								onUpdate={(values) => onChange?.(values[0])}
								options={genderOptions}
								validationState={errors.gender ? 'invalid' : undefined}
								errorPlacement="inside"
								errorMessage={error?.message}
								onBlur={onBlur}
								ref={ref}
							/>
						)}
					/>
				</FormRow>
			)}
		</>
	);
};
